export default __webpack_public_path__ + "static/media/cisco_logo.bbbfefcb.png";